
export const environment = {
    production:true,
    host:'https://site--deli--grqgr7rz9qhl.code.run/', 
    // host:'https://delivery-app-backend-dev-kdrs.1.us-1.fl0.io/',
    cloudinary_cloud:'dwklrqceu'
}

